import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { useAuth, API } from "@/App";
import { Card } from "@/components/ui/card";
import { Loader2, ArrowLeft, User } from "lucide-react";
import { MealPlansSection } from "@/pages/staff/PatientProfile";

export default function MealPlanDetail() {
  const { planId } = useParams();
  const { token } = useAuth();
  const navigate = useNavigate();
  const [patient, setPatient] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const h = { Authorization: `Bearer ${token}` };
    fetch(`${API}/staff/meal-plans/${planId}`, { headers: h }).then(async r => {
      if (!r.ok) throw new Error("Meal plan not found.");
      const plan = await r.json();
      const pr = await fetch(`${API}/staff/patient/${plan.patient_id}`, { headers: h });
      const prof = pr.ok ? await pr.json() : {};
      setPatient({ user_id: plan.patient_id, name: prof.patient?.name || plan.patient_name, phone: prof.patient?.phone, email: prof.patient?.email });
    }).catch(e => setError(e.message));
  }, [planId, token]);

  if (error) return <Card className="rounded-xl p-10 text-center text-sm text-stone-500" data-testid="meal-plan-detail-error">{error}</Card>;
  if (!patient) return <div className="flex items-center justify-center h-40"><Loader2 className="w-6 h-6 animate-spin text-stone-400" /></div>;

  return (
    <div className="space-y-4" data-testid="meal-plan-detail-page">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
        <div>
          <button onClick={() => navigate("/admin/meal-plans")} className="text-xs text-stone-500 hover:text-[#FF7A00] flex items-center gap-1" data-testid="back-to-meal-plans"><ArrowLeft className="w-3.5 h-3.5" />All meal plans</button>
          <h1 className="text-2xl font-extrabold text-stone-900 tracking-tight mt-1">Meal plan · {patient.name}</h1>
        </div>
        <Link to={`/admin/patients/${patient.user_id}`} className="text-xs text-[#FF7A00] hover:underline flex items-center gap-1" data-testid="open-patient-profile"><User className="w-3.5 h-3.5" />Open patient profile</Link>
      </div>
      <MealPlansSection key={planId} patientId={patient.user_id} token={token} s={{ name: patient.name, phone: patient.phone }} standalone initialPlanId={planId} onClose={() => navigate("/admin/meal-plans")} />
    </div>
  );
}
